module.exports = __webpack_public_path__ + "img/2.f887da55.png";